/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ days: NonNullable<unknown> }} Chat_Space_File_Replace_NoticeInputs */



/**
* | output |
* | --- |
* | "The current content is replaced. It stays restorable for {days} days." |
*
* @param {Chat_Space_File_Replace_NoticeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_space_file_replace_notice = /** @type {((inputs: Chat_Space_File_Replace_NoticeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Space_File_Replace_NoticeInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Der aktuelle Inhalt wird ersetzt. Er bleibt ${i?.days} Tage wiederherstellbar.`)
	return /** @type {LocalizedString} */ (`The current content is replaced. It stays restorable for ${i?.days} days.`)
});